import moment from 'moment'
import { v4 as uuid } from 'uuid'
import {
  fetchWithToken,
} from '@hublot-io/core-api/client'
import config from '../utils/apiUtils'

export const PlateauProductAnnexService = {
  getPlateauProductsAnnex(idPlateau) {
    const filter = JSON.stringify([{ 'field': 'idPlateau', 'operator': '=', 'value': idPlateau }])

    return fetchWithToken(`${config().syncService}/plateauProductAnnex?filters=${filter}`, {
      method: 'GET',
    }).then((response) => response.json())
  },
  save(customProductAnnex) {
    const lastUpdate = moment().format('YYYY-MM-DD HH:mm:ss')
    const customProductAnnexUUid = uuid()

    if (!customProductAnnex._id) {
      const finalCustomProductAnnex = {
        ...customProductAnnex,
        _id: customProductAnnexUUid,
        lastUpdate,
        deleted: false,
      }
      return fetchWithToken(`${config().syncService}/plateauProductAnnex`, {
        method: 'PUT',
        body: JSON.stringify([finalCustomProductAnnex]),
      }).then((body) => body.json())
        .then(() => ({
          ...finalCustomProductAnnex,
          idPlateau: finalCustomProductAnnex.idPlateau,
          lastUpdate,
        }))
    }
    return fetchWithToken(`${config().syncService}/plateauProductAnnex`, {
      method: 'PUT',
      body: JSON.stringify([{ ...customProductAnnex, lastUpdate }]),
    }).then((body) => body.json())
      .then(() => ({
        ...customProductAnnex,
        idPlateau: customProductAnnex.idPlateau,
        lastUpdate,
      }))
  },
}
